import { Users, BookOpen,  Shield, GitBranch,Activity, Search, Image, Mic, Clipboard, Heart, MessageSquare,  ShoppingCart, TreePine, Building } from 'lucide-react';
const projects = [
    // Smart Media (3 projects)
    {
  id: 1,
  title: "BiL-FaND",
  description: "Ensemble-based system detecting fake news in English and Urdu through text, data, and multimedia analysis.",
  category: "Smart Media",
  technologies: [
    "Multilingual BERT",
    "LSTM",
    "ResNet-101",
    "GRU",
    "BLEU Scoring"
  ],
  features: [
    "Textual analysis layer using Multilingual BERT achieving 87% accuracy",
    "Categorical data processing with LSTM achieving 97% accuracy",
    "Numerical data processing with LSTM achieving 94% accuracy",
    "Multimedia caption generation using ResNet-101 ",
    "Overall system accuracy of 92.07% in bilingual fake news detection"
  ],
  icon: <MessageSquare className="h-8 w-8 text-orange-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/bill-frind.jpg`,
  githubUrl: null,
  videoUrl: null, // Not available
  paperUrl: "https://link.springer.com/article/10.1007/s13042-024-02128-0"
},
    
    {
      id: 2,
      title: "Content Filtering System",
      description: "Transcribes video audio to detect sensitive keywords and uses computer vision to identify/blur explicit content.",
      category: "Smart Media",
      technologies: ["NLP", "Computer Vision"],
      features: [
        "Automatic screening of user-generated content",
        "Creates safer online environment",
        "Improves content moderation efficiency"
      ],
      icon: <MessageSquare className="h-8 w-8 text-orange-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/content-filtering.jpg`,
      githubUrl: null, 
      videoUrl: null,
      paperUrl: null 
    },
    {
      id: 3,
      title: "Social Insights",
      description: "Analyzes social media trends and user engagement patterns to provide actionable insights.",
      category: "Smart Media",
      technologies: ["Data Analytics", "Machine Learning"],
      features: [
        "Real-time trend analysis",
        "Audience engagement metrics",
        "Content performance and predictions against social accounts"
      ],
      icon: <MessageSquare className="h-8 w-8 text-orange-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/social-insights.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },

    // eHealth (3 projects)
    {
      id: 4,
      title: "Heart Failure Prediction",
      description: "System uses ML to analyze echocardiogram images and ECG data ",
      category: "eHealth",
      technologies: ["Machine Learning", "Medical Imaging"],
      features: [
        "Proactive and personalized treatment",
        "Earlier, more accurate diagnosis",
        "Improves patient outcomes through early intervention"
      ],
      icon: <Heart className="h-8 w-8 text-red-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/heart-failure.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 5,
      title: "DiagnoSysAI",
      description: "Healthcare tool that identifies possible diseases based on symptoms and recommends relevant tests.",
      category: "eHealth",
      technologies: ["Machine Learning", "Healthcare"],
      features: [
        "Faster screening in clinics with improved results",
        "Suggestions for telehealth diagnostic procedures",
        "Reduces all types of unnecessary Medical Tests"
      ],
      icon: <Heart className="h-8 w-8 text-red-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/diagnosys-ai.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 6,
      title: "Asthma Prediction",
      description: "Early detection of worsening asthma aims to predict daily asthma related ED visits and admissions.",
      category: "eHealth",
      technologies: ["Machine Learning", "Healthcare Analytics"],
      features: [
        "Predicts adverse impact of social factors like overcrowding",
        "Helps health providers take proactive measures",
        "Improves asthma outcomes through early intervention"
      ],
      icon: <Heart className="h-8 w-8 text-red-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/asthma-prediction.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: "https://pubmed.ncbi.nlm.nih.gov/38739297/"
    },

    // eBusiness (3 projects)
    {
      id: 7,
      title: "Visual Search Platform",
      description: "A shopping platform that uses images instead of text for product searches, making online browsing more intuitive.",
      category: "eBusiness",
      technologies: ["Computer Vision", "Machine Learning"],
      features: [
        "Customers can upload a photo to find matching or similar products",
        "Reduces language barriers for international shoppers",
        "Creates an inclusive online retail environment"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/visual-search.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 8,
      title: "Smart Shopping",
      description: "Enables brick and mortar retailers to track customer interests to better compete with online retail.",
      category: "eBusiness",
      technologies: ["Computer Vision", "Behavioral Analytics"],
      features: [
        "Provides unprecedented insight into customer behavior",
        "Helps and enhance optimize sales processes ",
        "Improves in-store shopping experience overall"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/smart-shopping.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: "https://dsrc.aut.ac.nz/our-research/research-projects/smart-shopping"
    },
    {
      id: 9,
      title: "Sales Outreach Bot",
      description: "Conversational AI that engages prospects, identifies high-potential leads, handles inquiries, and books meetings.",
      category: "eBusiness",
      technologies: ["NLP", "Conversational AI"],
      features: [
        "Handles high-volume, repetitive outreach",
        "Automates the all initial sales funnel stages",
        "Increases and improves sales productivity overall"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-purple-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/sales-bot.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },

    // eDocuments (2 projects)
    {
      id: 10,
      title: "DocuSense",
      description: "AI-powered document analysis system that automatically categorizes and tags documents for easy retrieval.",
      category: "eDocuments",
      technologies: ["NLP", "Document Analysis"],
      features: [
        "Automated document organization",
        "Intelligent search capabilities",
        "Reduces manual document handling"
      ],
      icon: <BookOpen className="h-8 w-8 text-blue-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/docusense.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 11,
      title: "Contract Insight",
      description: "Analyzes legal contracts to identify key clauses and potential risks using natural language processing.",
      category: "eDocuments",
      technologies: ["NLP", "Legal Tech"],
      features: [
        "Speeds up contract review process",
        "Identifies potential legal risks",
        "Summarizes key contract terms"
      ],
      icon: <BookOpen className="h-8 w-8 text-blue-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/contract-insight.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },

    // Smart City (2 projects)
    {
      id: 12,
      title: "Forensic Intelligence",
      description: "Analyzes forensic casework data to identify patterns in forensic science conducted.",
      category: "Smart City",
      technologies: ["Data Analytics", "Pattern Recognition"],
      features: [
        "Improves crime prevention ",
        "Supports recovery from crime",
        "Enhances forensic effectiveness"
      ],
      icon: <Building className="h-8 w-8 text-gray-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/forensic-intel.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: "https://dsrc.aut.ac.nz/our-research/research-projects/forensic-intelligence"
    },
    {
      id: 13,
      title: "Similar Crimes Identifier",
      description: "Finds similarities between crimes using AI and Ontology, visualized in a knowledge graph.",
      category: "Smart City",
      technologies: ["AI", "Ontology", "Knowledge Graphs"],
      features: [
        "Visual relationships between crimes",
        "Identifies crime patterns",
        "Supports law enforcement decision "
      ],
      icon: <Building className="h-8 w-8 text-gray-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/crime-identifier.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },

    // Smart City (3 projects)
    {
      id: 14,
      title: "ClickFix",
      description: "Mobile app that identifies defective items from photos and suggests suitable local repair services.",
      category: "Smart City",
      technologies: ["Computer Vision", "Location Services"],
      features: [
        "Quickly locate repair services",
        "Service providers understand problems",
        "Simplifies repair process"
      ],
      icon: <Building className="h-8 w-8 text-gray-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/clickfix.jpg`,
      githubUrl: null,
      videoUrl:  null,
      paperUrl: null
    },
    {
      id: 15,
      title: "HomeGuard",
      description: "Smart City security system that uses AI to detect unusual activity patterns and potential threats.",
      category: "Smart City",
      technologies: ["Computer Vision", "IoT"],
      features: [
        "Real-time threat detection",
        "Automated emergency alerts",
        "Energy-efficient monitoring"
      ],
      icon: <Building className="h-8 w-8 text-gray-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/homeguard.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 16,
      title: "Home Appliance Identifier",
      description: "Uses deep learning to identify faulty home appliances and suggest suitable handymen.",
      category: "Smart City",
      technologies: ["Deep Learning", "Image Classification"],
      features: [
        "Automatic identification of faulty appliances",
        "Reduces handyman search time",
        "Smart recommendation system"
      ],
      icon: <Building className="h-8 w-8 text-gray-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/home-appliance.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },

    // Additional projects with mixed availability
    {
      id: 17,
      title: "Customer Retention via Social Media",
      description: "Predicts customer churn using Twitter data and sentiment analysis.",
      category: "Smart Media",
      technologies: ["NLP", "Social Media Analysis", "BERT"],
      features: [
        "Predicts customer churn",
        "Analyzes customer sentiment",
        "Supports retail decision-making"
      ],
      icon:<MessageSquare className="h-8 w-8 text-orange-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/customer-retention.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 18,
      title: "User Interest Forecasting",
      description: "Identifies and predicts user interests over time using LDA, BERT, and ARIMA.",
      category: "eBusiness",
      technologies: ["Topic Modeling", "Time Series Forecasting"],
      features: [
        "Forecasts user interest using social data",
        "Topic modeling via LDA",
        "Interest-level prediction using ARIMA"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/user-interest.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: "https://ieeexplore.ieee.org/abstract/document/9972955"
    },
    {
      id: 19,
      title: "Saraiki Language Word Prediction",
      description: "Predicts next words in Saraiki using Word2Vec and Roberta language models.",
      category: "eDocuments",
      technologies: ["NLP", "Word Embeddings"],
      features: [
        "Supports regional language NLP",
        "Evaluates context-based word similarity",
        "Compares multiple embedding techniques"
      ],
      icon: <BookOpen className="h-8 w-8 text-yellow-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/saraiki-prediction.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: "https://ieeexplore.ieee.org/abstract/document/9972938"
    },
    {
      id: 20,
      title: "Skin Lesion Classification",
      description: "Classifies skin lesions using CNNs and feature reduction with 95.8% accuracy.",
      category: "eHealth",
      technologies: ["CNN", "Skin Cancer Detection"],
      features: [
        "Handles class imbalance in skin datasets",
        "Combines DarkNet and Inception V3",
        "Feature reduction with Moth Flame Optimization"
      ],
      icon: <Heart className="h-8 w-8 text-pink-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/skin-lesion.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: "https://www.mdpi.com/1424-8220/22/21/8311"
    },
    {
      id: 21,
      title: "GAN Story-to-Image Generator",
      description: "Generates cover images from text stories using Layout Guided GAN.",
      category: "eDocuments",
      technologies: ["GAN", "Text-to-Image"],
      features: [
        "Creates images based on text layout",
        "Enhances storybook illustration automation",
        "Supports multiple characters in image"
      ],
      icon: <BookOpen className="h-8 w-8 text-blue-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/gan-cover.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },


    {
    id: 22,
    title: "AI Companion",
    description: "An AI-powered companion that answers questions and engages in conversations.",
    category: "eBusiness",
    technologies: ["NLP", "ML", "Chatbots"],
    features: [
    "Engages in natural language conversations",
    "Provides the best relevant answers",
    "Learns and adapts on user interactions"
    ],
    icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
    logo: `${process.env.PUBLIC_URL}/logos/ai-companion.jpg`,
    githubUrl: "https://github.com/MuhammadAamirGulzar/Funny_AI_Companion",
    videoUrl: "https://github.com/MuhammadAamirGulzar/Funny_AI_Companion?tab=readme-ov-file",
    paperUrl: null
},

    {
      id: 23,
      title: "ImageMart",
      description: "Visual search system that finds products by image, optimizing shopping experience.",
      category: "eBusiness",
      technologies: ["Visual Search", "AI", "Computer Vision"],
      features: [
        "Optimizes shopping experience based on experience",
        "Accurate, fast product discovery",
        "Reduces scrolling time"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-teal-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/imagemart.jpg`,
      githubUrl: null,
      videoUrl: null,
      paperUrl: null
    },
    {
      id: 24,
      title: "VocalCraft-AI",
      description: "Generates editable promotional pamphlets through voice commands.",
      category: "eBusiness",
      technologies: ["Voice AI", "Text Generation", "Image Processing"],
      features: [
        "Creates editable pamphlets via voice",
        "Boosts marketing efficiency",
        "Easy and fast content generation"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/vocalcraft-ai.jpg`,
      githubUrl: "https://github.com/MuhammadAamirGulzar/Video_Ad_Generation",
      videoUrl: "https://github.com/MuhammadAamirGulzar/Video_Ad_Generation?tab=readme-ov-file#video-demo",
      paperUrl: null
    },
        {
      id: 25,
      title: "VoxAI",
      description: "An AI-powered platform that converts voice commands into SQL queries with a modern web interface.",
      category: "eBusiness",
      technologies: ["Voice Recognition", "Text-to-SQL", "React"],
      features: [
        "Convert spoken commands to text using OpenAI Whisper",
        "Transform natural language into SQL queries",
        "Intelligent chat capabilities using local LLM models"
      ],
      icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
      logo: `${process.env.PUBLIC_URL}/logos/voxai.jpg`,
      githubUrl: "https://github.com/MuhammadAamirGulzar/Voice_SQL_Bot",
      videoUrl: "https://github.com/MuhammadAamirGulzar/Voice_SQL_Bot?tab=readme-ov-file#-voxai---voice-to-sql-query-generation-platform",
      paperUrl: null
      },

      {
  id: 26,
  title: "CancerDetection",
  description: "Task-Specific Fine-Tuning via Bottleneck for Weakly-Supervised Pathology Whole Slide Image Classification.",
  category: "eHealth",
  technologies: ["PyTorch", "OpenSlide", "NVIDIA DALI", "DL"],
  features: [
  "Weakly-supervised pathology classification using variational information bottleneck.",
  "Top-k patch extraction",
  "End-to-end training pipeline for whole image classification with deep learning."
],
  icon: <Heart className="h-8 w-8 text-red-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/cancer-detection.jpg`,
  githubUrl: "https://github.com/MuhammadAamirGulzar/CancerDetection_VIB-Pipeline",
  videoUrl: null,
  paperUrl: "https://openaccess.thecvf.com/content/CVPR2023/html/Li_Task-Specific_Fine-Tuning_via_Variational_Information_Bottleneck_for_Weakly-Supervised_Pathology_Whole_CVPR_2023_paper.html"
},


{
  id: 27,
  title: "RAG Document Q&A System",
  description: "A Retrieval-Augmented Generation (RAG) system for document question answering and summarization.",
  category: "eDocuments",
  technologies: ["Streamlit", "ChromaDB", "Llama"],
  features: [
    "Ask questions about your documents and get accurate answers with source attribution",
    "Generate comprehensive summaries of uploaded documents",
    "Process PDF, DOCX, Excel (XLSX/XLS), and CSV files"
  ],
  icon: <BookOpen className="h-8 w-8 text-blue-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/rag-qna.jpg`,
  githubUrl: "https://github.com/MuhammadAamirGulzar/DrX_RAG_App",
  videoUrl: "https://github.com/MuhammadAamirGulzar/DrX_RAG_App?tab=readme-ov-file#rag-document-qa-system",
  paperUrl: null
},
{
  id: 28,
  title: "AI Product Video Generator Platform",
  description: "A full-stack web application that automates the creation of promotional product videos from any e-commerce product URL.",
  category: "eBusiness",
  technologies: [
    "React",
    "Zustand",
    "React Router",
    "Python",
    "BeautifulSoup",
    "Playwright",
    "Mistral LLM",
    "MoviePy",
    "Kokoro TTS"
  ],
  features: [
    "Responsive and intuitive frontend built with React, Zustand, and React Router",
    "Automated scraping of static and dynamic product data using BeautifulSoup and Playwright",
    "AI-powered script generation using Mistral LLM",
    "Professional video creation with MoviePy including image transitions and avatars",
  ],
  icon: <ShoppingCart className="h-8 w-8 text-green-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/ai-product-video-generator.png`,
  githubUrl: null,
  videoUrl: null, // Not available
  paperUrl: null // Not applicable
}, 

{
  id: 29,
  title: "Twitter Sentiment Analysis of Chiropractic Discourse",
  description: "A multi-method NLP pipeline for analyzing sentiment, topics, influencers, and geospatial patterns in chiropractic-related Twitter conversations from 2018–2025.",
  category: "Smart Media",
  technologies: [
    "Hugging Face Transformers",
    "FLAN-T5",
    "pyLDAvis",
    "Plotly",
    "NetworkX"
  ],
  features: [
    "35K chiropractic-related tweets collected and categorized into five thematic groups",
    "Fine-tuned FLAN-T5 model for three-class sentiment classification with weighted loss for imbalance",
    "Topic modeling with LDA and interactive visualization using pyLDAvis",
    "User-hashtag bipartite network analysis to identify influencers and community clusters",
  ],
  icon: <MessageSquare className="h-8 w-8 text-green-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/twitter_sentiment_analysis_logo.jpg`,
  githubUrl: null,
  videoUrl: null,
  paperUrl: null
},
{
  id: 30,
  title: "Livestock Health Monitoring Collar",
  description: "A hardware-based IoT collar device for real-time monitoring of livestock health, tracking temperature, heart rate, and movement, with centralized management via mobile and web dashboards.",
  category: "AgroTech",
  technologies: [
    "IoT Sensors (Temperature, Heart Rate, Accelerometer)",
    "Embedded Systems",
    "Mobile Application",
    "Web Dashboard",
    "Internet Connectivity"
  ],
  features: [
    "Collar device worn around the animal's neck with integrated sensors",
    "Real-time monitoring of temperature, heart rate, and movement/activity",
    "Automatic data transmission to mobile app for each animal",
    "Centralized admin dashboard for managing multiple animals",
    "Alerts for abnormal health indicators"
  ],
  icon: <TreePine className="h-8 w-8 text-green-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/livestock_health_collar.png`,
  githubUrl: null,
  videoUrl: null,
  paperUrl: null
},
{
  id: 31,
  title: "Voice-Enabled Livestock Marketplace",
  description: "An online marketplace for livestock and dairy products, similar to PakWheels, with integrated speech-to-text technology for fast, accessible ad posting.",
  category: "AgroTech",
  technologies: [
    "Web Platform",
    "Speech-to-Text Model (STT)",
    "Database for Listings",
    "Internet Connectivity"
  ],
  features: [
    "Marketplace for buying and selling livestock and dairy products",
    "Voice-based ad creation using speech-to-text",
    "Automatic generation of listing content from voice input",
    "Support for traditional text-based ad posting",
    "Categorized listings for easy browsing"
  ],
  icon: <TreePine className="h-8 w-8 text-green-600" />,
  logo: `${process.env.PUBLIC_URL}/logos/livestock_marketplace.png`,
  githubUrl: null,
  videoUrl: null,
  paperUrl: null
}

  ];

export default projects;